import { trackEvent } from "@/lib/analytics";
import { useT } from "@/i18n/LanguageContext";

/**
 * Official "Get it on Google Play" badge (localised PNGs in /public/badges/).
 * The official asset ships with built-in transparent padding (41px sides,
 * 41px top/bottom on the 646×250 canvas); we compensate with negative
 * margins so the visible badge matches the Apple badge height exactly.
 */

const PLAYSTORE_URL = process.env.REACT_APP_PLAYSTORE_URL || "";
const BADGE_LANGS = ["en", "nl", "de", "fr", "es"];
const ASSET_H = 250;
const CONTENT_H = 168; // visible badge height inside the asset
const PAD = 41;        // transparent padding inside the asset

export default function GooglePlayBadge({ visibleHeight = 54, placement = "google_play_badge", testid = "playstore-cta" }) {
  const { lang } = useT();
  const src = `/badges/google-play-${BADGE_LANGS.includes(lang) ? lang : "en"}.png`;
  const renderH = Math.round(visibleHeight * (ASSET_H / CONTENT_H));
  const trim = Math.round(renderH * (PAD / ASSET_H));

  return (
    <a
      href={PLAYSTORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      onClick={() => trackEvent("google_play_click", { placement, has_store_url: !!PLAYSTORE_URL })}
      aria-label="Get Virtue Guide on Google Play"
      className="inline-block transition-transform duration-300 hover:scale-[1.03] focus:outline-none focus-visible:ring-2 focus-visible:ring-gold/60"
      style={{ lineHeight: 0 }}
    >
      <img
        src={src}
        alt="Get it on Google Play"
        style={{ height: `${renderH}px`, width: "auto", display: "block", margin: `-${trim}px` }}
        draggable={false}
      />
    </a>
  );
}
